/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorJwVideo as ResolvedLabradorJwVideo } from 'base/components/labrador/JwVideo';

export const LabradorJwVideo: typeof ResolvedLabradorJwVideo = withLabradorInstanceof((props) => {
    return <ResolvedLabradorJwVideo {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorJwVideoProps = PropsFromComponent<typeof LabradorJwVideo>;
